const canvas = document.createElement('canvas');
const context = canvas.getContext('2d');
context.font = getComputedStyle(document.body).font;

function getTextWidth(text) {
  return context.measureText(text).width;
}

export { getTextWidth };